export class StoredFile {
    filename: string;
    version: number;
    path: string;
    guid: string;
    size: number;
    lastmodified: number;
    is_dir: boolean; 

    id: number;
    infolder: number;

    highlights: string[];
    tags: string[];
    resources: string[];

    versions: StoredFile[] = [];

    constructor(init?: Partial<StoredFile>) {
        if (init == null) {
            return;
        }
        Object.assign(this, init);
    }

    public isDirectory(): boolean {
        return this.is_dir;
    }

    public read(src: any): StoredFile {

        if (src) {
            this.filename = src.filename || src.name || '';
            this.path = src.path || '';
            this.guid = src.guid || '';

            if (src.id)
            this.id = +src.id;

            if (src.version)
            this.version = +src.version;
            
            if (src.infolder)
            this.infolder = +src.infolder;

            this.size = +src.size;
            this.lastmodified = +src.lastmodified;
            if (src.highlights) {
                this.highlights = src.highlights;
            }
            if (src.tags) {
                this.tags = src.tags;
            }
            if (src.resources) {
                this.resources = src.resources;
            }
            if (src.resource) {
                this.resources = [src.resource];
            }

            if (src.versions) {
                this.versions = src.versions;
            }
        }

        return this;
    }
}